import React, { useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";

export const FormEditPin = ({ data, setData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Put({
        url: api_Routes.PinsAdvertising.Edit + id,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Ads-Pin");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          required
          autoComplete="off"
          value={data?.title}
          onChange={handleInputChange}
          variant="outlined"
        />

        <TextField
          fullWidth
          margin="normal"
          label="Pin URL"
          name="pin_url"
          required
          autoComplete="off"
          value={data?.pin_url}
          onChange={handleInputChange}
          variant="outlined"
        />

        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          required
          autoComplete="off"
          value={data?.description}
          onChange={handleInputChange}
          variant="outlined"
          multiline
          rows={4}
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>Pin Position</InputLabel>
          <Select
            label="Pin Position"
            name="pin_place"
            value={data?.pin_place || ""}
            onChange={handleInputChange}
            required
          >
            <MenuItem value="top">Top</MenuItem>
            <MenuItem value="down">Bottom</MenuItem>
          </Select>
        </FormControl>
      </div>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
